module.exports = __webpack_public_path__ + "img/project13_5.jpg.7caa35d6.webp";